import { useConnect } from '@lore/query-connect';

export default function useInvitations(state, network, schoolStart, schoolEnd, extra = {}) {
  return useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          event: {
            $where: {
              site: {
                $where: {
                  state: {
                    $ilike: state
                  }
                }
              }
            }
          },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          ...extra,
          request: { $not: 'Outreach' }
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });
}
